import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar-content display-y-center display-s-b" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import { onBeforeMount, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { navbarList } from '@/views/home/dataConfig';
import { getSessionData, setSessionData } from '@/handle/sessionHandle';
import { SESSION_STORE } from '@/config/constConfig';
import { freshBalance } from '@/handle/balanceHandle';


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const router = useRouter();

let state = reactive({
    navbarIndex: 0 as number
});

onBeforeMount(() => {
    initIndex();
    getIndex();
});

function initIndex() {
    if (router.currentRoute.value.path == "/") {
        setSessionData(SESSION_STORE.NAVBAR_INDEX.key, 0);
    }
}

function getIndex(): number {
    let index = getSessionData(SESSION_STORE.NAVBAR_INDEX.key);
    if (index) {
        state.navbarIndex = index;
    }
    return state.navbarIndex;
}

function onLink(item: any, index: number) {
    if (index == 0) {
        freshBalance();
    }
    state.navbarIndex = index;
    setSessionData(SESSION_STORE.NAVBAR_INDEX.key, index);
    router.push(item.path);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbarList), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["bar display-x-end display-y-center display-column", index==_unref(state).navbarIndex?'active':'']),
        onClick: ($event: any) => (onLink(item, index))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({blackBg: index == 2})
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["img-div", {special: index == 2}])
          }, [
            _createElementVNode("img", {
              src: index==_unref(state).navbarIndex?item.iconActive:item.icon
            }, null, 8, _hoisted_3)
          ], 2)
        ], 2),
        _createElementVNode("span", null, _toDisplayString(item.text), 1)
      ], 10, _hoisted_2))
    }), 256))
  ]))
}
}

})